export default __webpack_public_path__ + "static/media/apple-icon-white.752e5894.webp";